import React, { useEffect, useState } from "react"

import axios from "axios"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import Overlay from "../../atoms/overlay"
import Modal from "../../molecules/modal"

const Geolocation = ({ custom }) => {
  const { site, allSanityDictionary, allSanityCountry } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
        allSanityCountry {
          nodes {
            url
            abbreviation
          }
        }
      }
    `
  )
  const country = allSanityCountry.nodes.find(
    (c) => c.url === site.siteMetadata.siteUrl
  ).abbreviation
  const [activeModal, setActiveModal] = useState(false)

  const openModal = () => {
    setActiveModal(true)
    document.body.classList.add("disableScroll")
  }

  const closeModal = (e) => {
    e.preventDefault()
    if (e.target === e.currentTarget) {
      document.body.classList.remove("disableScroll")
      localStorage.setItem("beenPrompted", true)
      setActiveModal(false)
    }
  }

  const redirect = () => {
    const redirectUrl = allSanityCountry.nodes.find(
      (c) => c.abbreviation !== country
    ).url
    window.location.href = redirectUrl
  }

  useEffect(() => {
    if (!localStorage.getItem("beenPrompted")) {
      axios
        .get("/.netlify/functions/geolocation")
        .then((res) => {
          if (res.data !== country) {
            openModal()
          }
        })
        .catch(() => null)
    }
  }, [])

  return (
    <Overlay trigger={activeModal} event={closeModal} custom={custom}>
      <Modal
        closeModal={closeModal}
        message={
          allSanityDictionary.nodes.find(
            (item) =>
              item.key.current === `geolocation_${country.toLowerCase()}_msg`
          )?.value
        }
        yesEvent={redirect}
        yesText={
          allSanityDictionary.nodes.find(
            (item) =>
              item.key.current === `geolocation_${country.toLowerCase()}_go`
          )?.value
        }
        noText={
          allSanityDictionary.nodes.find(
            (item) =>
              item.key.current === `geolocation_${country.toLowerCase()}_stay`
          )?.value
        }
      />
    </Overlay>
  )
}

export default Geolocation

Geolocation.propTypes = {
  custom: PropTypes.bool.isRequired,
}
